import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_HOUSE, CREATING_HOUSE, GETTING_HOUSES, GET_HOUSES, HOUSING_ERROR, SET_SUCCESS, CREATE_HOUSE_BLOCK, CREATING_HOUSE_BLOCK } from "../types"

export const createHouse = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_HOUSE,
            payload: true
        })
        const response = await axios.post(`${baseUrl}/student-housing/houses`, payload, { headers })
        
        dispatch({
            type: CREATE_HOUSE  ,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'New house(s) created successfully!'
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: HOUSING_ERROR,
            // payload: error.response.data
            error
        })
    }
}

export const fetchHouses = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/student-housing/houses`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_HOUSES,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_HOUSES,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: HOUSING_ERROR,
            error
        })
    }
}

export const createHouseBlock = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_HOUSE_BLOCK,
            payload: true
        })
        const response = await axios.post(`${baseUrl}/student-housing/house-blocks`, payload, { headers })
        
        dispatch({
            type: CREATE_HOUSE_BLOCK,
            payload: response.data
        })
        
    }
    catch(error){
        dispatch({
            type: HOUSING_ERROR,
            error
        })
    }
}

export const clearCreatedHouseBlock = () => async (dispatch) => {    
    dispatch({
        type: CREATE_HOUSE_BLOCK,
        payload: null
    })
}

export const deleteHouse = (houseId) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_HOUSE,
            payload: true
        })
        
        await axios.delete(`${baseUrl}/student-housing/houses/${houseId}`, { headers })
        
        dispatch({
            type: SET_SUCCESS,
            payload: 'House deleted successfully!'
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: HOUSING_ERROR,
            // payload: error.response.data
            error
        })
    }
}
